import { render, staticRenderFns } from "./Area8.vue?vue&type=template&id=4dcca632&scoped=true&"
import script from "./Area8.vue?vue&type=script&lang=js&"
export * from "./Area8.vue?vue&type=script&lang=js&"
import style0 from "./Area8.vue?vue&type=style&index=0&id=4dcca632&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcca632",
  null
  
)

export default component.exports